/* import __COLOCATED_TEMPLATE__ from './zendesk.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type HandoffToExternalTicket from 'embercom/models/operator/visual-builder/step/handoff-to-external-ticket';

interface Args {
  step: HandoffToExternalTicket;
  readOnly?: boolean;
}

export default class ZendeskExternalTicketHandoffStepComponent extends Component<Args> {
  @service declare intl: IntlService;

  get stepTitle() {
    return this.intl.t('operator.workflows.visual-builder.create-external-ticket.title', {
      integration: 'Zendesk', // eslint-disable-line @intercom/intercom/no-bare-strings
      htmlSafe: true,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::ExternalTicketHandoffSteps::Zendesk': typeof ZendeskExternalTicketHandoffStepComponent;
  }
}
